<div class="wizard-loading-overlay" *ngIf="loadingState.isLoading">
  <div class="wizard-loading-container">
    <div class="wizard-loading-content">
      <!-- Spinner icon -->
      <!-- <div class="loading-spinner">
        <mat-spinner diameter="48" [value]="loadingState.progress" mode="determinate"></mat-spinner>
      </div> -->

      <!-- Progress percentage -->
      <div class="progress-percentage">
        {{ loadingState.progress }}%
      </div>

      <!-- Loading message -->
      <div class="loading-message">
        {{ loadingState.message | translate }}
      </div>

      <!-- Progress bar -->
      <div class="progress-bar-container">
        <mat-progress-bar 
          mode="determinate" 
          [value]="loadingState.progress"
        ></mat-progress-bar>
      </div>
    </div>
  </div>
</div>
